'use client'

import { Box, Typography } from '@mui/material'
import { Link } from '@assets-components'
import { Image } from '@media-components'
import type { StandardCardData } from '@components/common'
import { getStyles } from '@utils/styles'
import defaultStyles from './styles'

type SearchCaseStudyCardProps = StandardCardData

export function SearchCaseStudyCard({
  title,
  href,
  imageData,
  headerData,
  caseStudyDateRange,
}: SearchCaseStudyCardProps) {
  const styles = getStyles(defaultStyles)
  const isLink = Boolean(href)
  const logoData = headerData?.imageData

  return (
    <Box
      {...styles('card')}
      {...(isLink
        ? {
            component: Link,
            href,
          }
        : {})}
    >
      {imageData ? (
        <Image
          {...imageData}
          {...styles('image')}
          alt={imageData.alt || title}
        />
      ) : null}
      <Box {...styles('content')}>
        {logoData ? (
          <Image
            {...logoData}
            {...styles('logo')}
            alt={logoData.alt || title}
          />
        ) : null}
        {title ? (
          <Typography
            variant="body1.600"
            component="h3"
            color="text.primary"
            {...styles('title')}
          >
            {title}
          </Typography>
        ) : null}
        {caseStudyDateRange ? (
          <Typography variant="body3.500" color="text.secondary">
            {caseStudyDateRange}
          </Typography>
        ) : null}
      </Box>
    </Box>
  )
}
